import { render, staticRenderFns } from "./conferenceForm.vue?vue&type=template&id=6485b69b&scoped=true&"
import script from "./conferenceForm.vue?vue&type=script&lang=js&"
export * from "./conferenceForm.vue?vue&type=script&lang=js&"
import style0 from "./conferenceForm.vue?vue&type=style&index=0&id=6485b69b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6485b69b",
  null
  
)

export default component.exports